import LandingFrame from './LandingFrame';
import influencerHtml from '../../../public/landing/influencer.html?raw';

const Influencer = () => <LandingFrame html={influencerHtml} title="소셜듀오 · 인플루언서" />;

export default Influencer;
